import React from 'react';
import { Button } from './ui/button';
export function Hero() {
  return <section className="relative min-h-auto md:min-h-screen flex flex-col" data-id="element-182">
      {/* Parallax Background */}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat bg-fixed z-0" style={{
      backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/rKmTiiTJfXnCYmugftczaq/queen-creek-hero-1764826484503.webp")'
    }} data-id="element-183" />

      {/* Bottom-up gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-charcoal/90 via-charcoal/50 to-charcoal/20 z-[1]" data-id="element-184" />

      {/* Left-side vignette gradient for text readability */}
      <div className="absolute inset-0 z-[1]" style={{
      background: 'linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.55) 35%, rgba(0,0,0,0.15) 65%, rgba(0,0,0,0) 100%)'
    }} data-id="element-185" />

      {/* Main Content */}
      <div className="relative z-10 flex-1 flex flex-col justify-end pt-32 pb-8 md:pb-32" data-id="element-186">
        <div className="container mx-auto px-4 md:px-6" data-id="element-187">
          <div className="max-w-4xl" data-id="element-188">
            <p className="text-xs md:text-sm font-bold tracking-[0.25em] uppercase mb-4 md:mb-6" style={{
            color: '#E5C77A',
            textShadow: '0 2px 16px rgba(0,0,0,0.7), 0 1px 3px rgba(0,0,0,0.5)'
          }} data-id="element-189">
              Scottsdale Based. Maricopa County Wide.
            </p>
            <h1 className="font-serif text-[28px] md:text-6xl lg:text-7xl text-white leading-tight mb-6 font-semibold" style={{
            textShadow: '0 2px 16px rgba(0,0,0,0.7), 0 1px 3px rgba(0,0,0,0.5)'
          }} data-id="element-190">
              List your home for just{' '}
              <span className="font-extrabold" style={{
              color: '#C0392B',
              fontSize: '1.12em',
              textShadow: '0 0 30px rgba(255,255,255,0.4), 0 0 60px rgba(255,255,255,0.2), 0 2px 12px rgba(0,0,0,0.6)'
            }} data-id="element-191">
                1%
              </span>
              .
            </h1>
            <p className="font-sans text-lg md:text-xl max-w-2xl mb-8 md:mb-10 leading-relaxed font-medium" style={{
            color: '#F5F0E8',
            textShadow: '0 2px 16px rgba(0,0,0,0.7), 0 1px 3px rgba(0,0,0,0.5)'
          }} data-id="element-192">
              Everything you expect from a full service realtor. Except the high
              commission.
            </p>

            <div className="relative z-10 flex flex-col sm:flex-row gap-3 sm:gap-4 mb-10 md:mb-16" data-id="element-193">
              <Button className="bg-brick-red hover:bg-brick-red-dark text-white h-12 md:h-14 px-8 text-base md:text-lg w-full sm:w-auto" data-id="element-194">
                Book a Free Consultation
              </Button>
              <Button variant="outline" className="border-white text-white hover:bg-white hover:text-charcoal bg-transparent h-12 md:h-14 px-8 text-base md:text-lg w-full sm:w-auto" data-id="element-195">
                See How Much You'll Save
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Stats Strip — relative on mobile, absolute on desktop */}
      <div className="relative md:absolute md:bottom-0 md:left-0 md:right-0 z-[5] border-t border-gold/30" style={{
      backgroundColor: 'rgba(10,10,10,0.92)'
    }} data-id="element-196">
        <div className="container mx-auto px-4 md:px-6 py-6" data-id="element-197">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8" data-id="element-198">
            <div className="flex flex-col" data-id="element-199">
              <span className="font-serif text-2xl md:text-3xl text-white mb-1" data-id="element-200">
                $0
              </span>
              <span className="text-sm text-white/80" data-id="element-201">
                No upfront cost to list
              </span>
            </div>
            <div className="flex flex-col" data-id="element-202">
              <span className="font-serif text-2xl md:text-3xl text-white mb-1" data-id="element-203">
                1%
              </span>
              <span className="text-sm text-white/80" data-id="element-204">Listing commission</span>
            </div>
            <div className="flex flex-col" data-id="element-205">
              <span className="font-serif text-2xl md:text-3xl text-white mb-1" data-id="element-206">
                100+
              </span>
              <span className="text-sm text-white/80" data-id="element-207">
                Sites your home is listed on
              </span>
            </div>
            <div className="flex flex-col" data-id="element-208">
              <span className="font-serif text-2xl md:text-3xl text-white mb-1" data-id="element-209">
                $25K+
              </span>
              <span className="text-sm text-white/80" data-id="element-210">
                Average seller savings
              </span>
            </div>
          </div>
          <div className="mt-6 pt-4 border-t border-white/10 flex items-center gap-3" data-id="element-211">
            <span className="text-xs text-white/60 uppercase tracking-wider" data-id="element-212">
              Brokered by AZ Dream Homes
            </span>
          </div>
        </div>
      </div>
    </section>;
}